function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/twostepcaretmovement
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
/**
 * This plugin enables the two-step caret (phantom) movement behavior for
 * {@link module:typing/twostepcaretmovement~TwoStepCaretMovement#registerAttribute registered attributes}
 * on arrow right (<kbd>→</kbd>) and left (<kbd>←</kbd>) key press.
 *
 * Thanks to this (phantom) caret movement the user is able to type before/after as well as at the
 * beginning/end of an attribute.
 *
 * **Note:** This plugin support right–to–left (Arabic, Hebrew, etc.) content by mirroring its behavior
 * but for the sake of simplicity examples showcase only left–to–right use–cases.
 *
 * # Forward movement
 *
 * ## "Entering" an attribute:
 *
 * When this plugin is enabled and registered for the `a` attribute and the selection is right before it
 * (at the attribute boundary), pressing the right arrow key will not move the selection but update its
 * attributes accordingly:
 *
 * * When enabled:
 *
 *   		foo{}<$text a="true">bar</$text>
 *
 *    <kbd>→</kbd>
 *
 *   		foo<$text a="true">{}bar</$text>
 *
 * * When disabled:
 *
 *   		foo{}<$text a="true">bar</$text>
 *
 *   <kbd>→</kbd>
 *
 *   		foo<$text a="true">b{}ar</$text>
 *
 *
 * ## "Leaving" an attribute:
 *
 * * When enabled:
 *
 *   		<$text a="true">bar{}</$text>baz
 *
 *    <kbd>→</kbd>
 *
 *   		<$text a="true">bar</$text>{}baz
 *
 * * When disabled:
 *
 *   		<$text a="true">bar{}</$text>baz
 *
 *   <kbd>→</kbd>
 *
 *   		<$text a="true">bar</$text>b{}az
 *
 * # Backward movement
 *
 * * When enabled:
 *
 *   		<$text a="true">bar</$text>{}baz
 *
 *    <kbd>←</kbd>
 *
 *   		<$text a="true">bar{}</$text>baz
 *
 * * When disabled:
 *
 *   		<$text a="true">bar</$text>{}baz
 *
 *   <kbd>←</kbd>
 *
 *   		<$text a="true">ba{}r</$text>b{}az
 *
 * # Multiple attributes
 *
 * * When enabled and many attributes starts or ends at the same position:
 *
 *   		<$text a="true" b="true">bar</$text>{}baz
 *
 *    <kbd>←</kbd>
 *
 *   		<$text a="true" b="true">bar{}</$text>baz
 *
 * * When enabled and one procedes another:
 *
 *   		<$text a="true">bar</$text><$text b="true">{}bar</$text>
 *
 *    <kbd>←</kbd>
 *
 *   		<$text a="true">bar{}</$text><$text b="true">bar</$text>
 *
 */

var TwoStepCaretMovement = /*#__PURE__*/function (_Plugin) {
  _inherits(TwoStepCaretMovement, _Plugin);

  var _super = _createSuper(TwoStepCaretMovement);

  /**
   * @inheritDoc
   */
  function TwoStepCaretMovement(editor) {
    var _this;

    _classCallCheck(this, TwoStepCaretMovement);

    _this = _super.call(this, editor);
    /**
     * A set of attributes to handle.
     *
     * @protected
     * @property {module:typing/twostepcaretmovement~TwoStepCaretMovement}
     */

    _this.attributes = new Set();
    /**
     * The current UID of the overridden gravity, as returned by
     * {@link module:engine/model/writer~Writer#overrideSelectionGravity}.
     *
     * @private
     * @member {String}
     */

    _this._overrideUid = null;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TwoStepCaretMovement, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var model = editor.model;
      var view = editor.editing.view;
      var locale = editor.locale;
      var modelSelection = model.document.selection; // Listen to keyboard events and handle the caret movement according to the 2-step caret logic.

      this.listenTo(view.document, 'arrowKey', function (evt, data) {
        // This implementation works only for collapsed selection.
        if (!modelSelection.isCollapsed) {
          return;
        } // When user tries to expand the selection or jump over the whole word or to the beginning/end then
        // two-steps movement is not necessary.


        if (data.shiftKey || data.altKey || data.ctrlKey) {
          return;
        }

        var arrowRightPressed = data.keyCode == keyCodes.arrowright;
        var arrowLeftPressed = data.keyCode == keyCodes.arrowleft; // When neither left or right arrow has been pressed then do noting.

        if (!arrowRightPressed && !arrowLeftPressed) {
          return;
        }

        var contentDirection = locale.contentLanguageDirection;
        var isMovementHandled = false;

        if (contentDirection === 'ltr' && arrowRightPressed || contentDirection === 'rtl' && arrowLeftPressed) {
          isMovementHandled = _this2._handleForwardMovement(data);
        } else {
          isMovementHandled = _this2._handleBackwardMovement(data);
        } // Stop the keydown event if the two-step caret movement handled it. Avoid collisions
        // with other features which may also take over the caret movement (e.g. Widget).


        if (isMovementHandled === true) {
          evt.stop();
        }
      }, {
        context: '$text',
        priority: 'highest'
      });
      /**
       * A flag indicating that the automatic gravity restoration should not happen upon the next
       * gravity restoration.
       * {@link module:engine/model/selection~Selection#event:change:range} event.
       *
       * @private
       * @member {String}
       */

      this._isNextGravityRestorationSkipped = false; // The automatic gravity restoration logic.

      this.listenTo(modelSelection, 'change:range', function (evt, data) {
        // Skipping the automatic restoration is needed if the selection should change
        // but the gravity must remain overridden afterwards. See the #handleBackwardMovement
        // to learn more.
        if (_this2._isNextGravityRestorationSkipped) {
          _this2._isNextGravityRestorationSkipped = false;
          return;
        } // Skip automatic restore when the gravity is not overridden — simply, there's nothing to restore
        // at this moment.


        if (!_this2._isGravityOverridden) {
          return;
        } // Skip automatic restore when the change is indirect AND the selection is at the attribute boundary.
        // It means that e.g. if the change was external (collaboration) and the user had their
        // selection around the link, its gravity should remain intact in this change:range event.


        if (!data.directChange && isBetweenDifferentAttributes(modelSelection.getFirstPosition(), _this2.attributes)) {
          return;
        }

        _this2._restoreGravity();
      });
    }
    /**
     * Registers a given attribute for the two-step caret movement.
     *
     * @param {String} attribute Name of the attribute to handle.
     */

  }, {
    key: "registerAttribute",
    value: function registerAttribute(attribute) {
      this.attributes.add(attribute);
    }
    /**
     * Updates the document selection and the view according to the two–step caret movement state
     * when moving **forwards**. Executed upon `keypress` in the {@link module:engine/view/view~View}.
     *
     * @private
     * @param {module:engine/view/observer/domeventdata~DomEventData} data Data of the key press.
     * @returns {Boolean} `true` when the handler prevented caret movement
     */

  }, {
    key: "_handleForwardMovement",
    value: function _handleForwardMovement(data) {
      var attributes = this.attributes;
      var model = this.editor.model;
      var selection = model.document.selection;
      var position = selection.getFirstPosition(); // DON'T ENGAGE 2-SCM if gravity is already overridden. It means that we just entered
      //
      // 		<paragraph>foo<$text attribute>{}bar</$text>baz</paragraph>
      //
      // or left the attribute
      //
      // 		<paragraph>foo<$text attribute>bar</$text>{}baz</paragraph>
      //
      // and the gravity will be restored automatically.

      if (this._isGravityOverridden) {
        return false;
      } // DON'T ENGAGE 2-SCM when the selection is at the beginning of the block AND already has the
      // attribute:
      // * when the selection was initially set there using the mouse,
      // * when the editor has just started
      //
      //		<paragraph><$text attribute>{}bar</$text>baz</paragraph>
      //


      if (position.isAtStart && hasAnyAttribute(selection, attributes)) {
        return false;
      } // ENGAGE 2-SCM When at least one of the observed attributes changes its value (incl. starts, ends).
      //
      //		<paragraph>foo<$text attribute>bar{}</$text>baz</paragraph>
      //		<paragraph>foo<$text attribute>bar{}</$text><$text otherAttribute>baz</$text></paragraph>
      //		<paragraph>foo<$text attribute=1>bar{}</$text><$text attribute=2>baz</$text></paragraph>
      //		<paragraph>foo{}<$text attribute>bar</$text>baz</paragraph>
      //


      if (isBetweenDifferentAttributes(position, attributes)) {
        preventCaretMovement(data);

        this._overrideGravity();

        return true;
      }
    }
    /**
     * Updates the document selection and the view according to the two–step caret movement state
     * when moving **backwards**. Executed upon `keypress` in the {@link module:engine/view/view~View}.
     *
     * @private
     * @param {module:engine/view/observer/domeventdata~DomEventData} data Data of the key press.
     * @returns {Boolean} `true` when the handler prevented caret movement
     */

  }, {
    key: "_handleBackwardMovement",
    value: function _handleBackwardMovement(data) {
      var attributes = this.attributes;
      var model = this.editor.model;
      var selection = model.document.selection;
      var position = selection.getFirstPosition(); // When the gravity is already overridden (by this plugin), it means we are on the two-step position.
      // Prevent the movement, restore the gravity and update selection attributes.
      //
      //		<paragraph>foo<$text attribute=1>bar</$text><$text attribute=2>{}baz</$text></paragraph>
      //		<paragraph>foo<$text attribute>bar</$text><$text otherAttribute>{}baz</$text></paragraph>
      //		<paragraph>foo<$text attribute>{}bar</$text>baz</paragraph>
      //		<paragraph>foo<$text attribute>bar</$text>{}baz</paragraph>
      //

      if (this._isGravityOverridden) {
        preventCaretMovement(data);

        this._restoreGravity();

        setSelectionAttributesFromTheNodeBefore(model, attributes, position);
        return true;
      } else {
        // REMOVE SELECTION ATTRIBUTE when restoring gravity towards a non-existent content at the
        // beginning of the block.
        //
        // 		<paragraph>{}<$text attribute>bar</$text></paragraph>
        //
        if (position.isAtStart) {
          if (hasAnyAttribute(selection, attributes)) {
            preventCaretMovement(data);
            setSelectionAttributesFromTheNodeBefore(model, attributes, position);
            return true;
          }

          return false;
        } // When we are moving from natural gravity, to the position of the 2SCM, we need to override the gravity,
        // and make sure it won't be restored. Unless it's at the end of the block and an observed attribute.
        // We need to check if the caret is a one position before the attribute boundary:
        //
        //		<paragraph>foo<$text attribute=1>bar</$text><$text attribute=2>b{}az</$text></paragraph>
        //		<paragraph>foo<$text attribute>bar</$text><$text otherAttribute>b{}az</$text></paragraph>
        //		<paragraph>foo<$text attribute>b{}ar</$text>baz</paragraph>
        //		<paragraph>foo<$text attribute>bar</$text>b{}az</paragraph>
        //


        if (isStepAfterAnyAttributeBoundary(position, attributes)) {
          // ENGAGE 2-SCM if the selection has no attribute. This may happen when the user
          // left the attribute using a FORWARD 2-SCM.
          //
          // 		<paragraph><$text attribute>bar</$text>{}</paragraph>
          //
          if (position.isAtEnd && !hasAnyAttribute(selection, attributes) && isBetweenDifferentAttributes(position, attributes)) {
            preventCaretMovement(data);
            setSelectionAttributesFromTheNodeBefore(model, attributes, position);
            return true;
          } // Skip the automatic gravity restore upon the next selection#change:range event.
          // If not skipped, it would automatically restore the gravity, which should remain
          // overridden.


          this._isNextGravityRestorationSkipped = true;

          this._overrideGravity(); // Don't return "true" here because we didn't call _preventCaretMovement.
          // Returning here will destabilize the filler logic, which also listens to
          // keydown (and the event would be stopped).


          return false;
        }
      }
    }
    /**
     * `true` when the gravity is overridden for the plugin.
     *
     * @readonly
     * @private
     * @type {Boolean}
     */

  }, {
    key: "_isGravityOverridden",
    get: function get() {
      return !!this._overrideUid;
    }
    /**
     * Overrides the gravity using the {@link module:engine/model/writer~Writer model writer}
     * and stores the information about this fact in the {@link #_overrideUid}.
     *
     * A shorthand for {@link module:engine/model/writer~Writer#overrideSelectionGravity}.
     *
     * @private
     */

  }, {
    key: "_overrideGravity",
    value: function _overrideGravity() {
      this._overrideUid = this.editor.model.change(function (writer) {
        return writer.overrideSelectionGravity();
      });
    }
    /**
     * Restores the gravity using the {@link module:engine/model/writer~Writer model writer}.
     *
     * A shorthand for {@link module:engine/model/writer~Writer#restoreSelectionGravity}.
     *
     * @private
     */

  }, {
    key: "_restoreGravity",
    value: function _restoreGravity() {
      var _this3 = this;

      this.editor.model.change(function (writer) {
        writer.restoreSelectionGravity(_this3._overrideUid);
        _this3._overrideUid = null;
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TwoStepCaretMovement';
    }
  }]);

  return TwoStepCaretMovement;
}(Plugin); // Checks whether the selection has any of given attributes.
//
// @param {module:engine/model/documentselection~DocumentSelection} selection
// @param {Iterable.<String>} attributes


export { TwoStepCaretMovement as default };

function hasAnyAttribute(selection, attributes) {
  var _iterator = _createForOfIteratorHelper(attributes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var observedAttribute = _step.value;

      if (selection.hasAttribute(observedAttribute)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
} // Applies the given attributes to the current selection using using the
// values from the node before the current position. Uses
// the {@link module:engine/model/writer~Writer model writer}.
//
// @param {module:engine/model/model~Model}
// @param {Iterable.<String>} attributess
// @param {module:engine/model/position~Position} position


function setSelectionAttributesFromTheNodeBefore(model, attributes, position) {
  var nodeBefore = position.nodeBefore;
  model.change(function (writer) {
    if (nodeBefore) {
      writer.setSelectionAttribute(nodeBefore.getAttributes());
    } else {
      writer.removeSelectionAttribute(attributes);
    }
  });
} // Prevents the caret movement in the view by calling `preventDefault` on the event data.
//
// @alias data.preventDefault


function preventCaretMovement(data) {
  data.preventDefault();
} // Checks whether the step before `isBetweenDifferentAttributes()`.
//
// @param {module:engine/model/position~Position} position
// @param {String} attribute


function isStepAfterAnyAttributeBoundary(position, attributes) {
  var positionBefore = position.getShiftedBy(-1);
  return isBetweenDifferentAttributes(positionBefore, attributes);
} // Checks whether the given position is between different values of given attributes.
//
// @param {module:engine/model/position~Position} position
// @param {Iterable.<String>} attributes


function isBetweenDifferentAttributes(position, attributes) {
  var nodeBefore = position.nodeBefore,
      nodeAfter = position.nodeAfter;

  var _iterator2 = _createForOfIteratorHelper(attributes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var observedAttribute = _step2.value;
      var attrBefore = nodeBefore ? nodeBefore.getAttribute(observedAttribute) : undefined;
      var attrAfter = nodeAfter ? nodeAfter.getAttribute(observedAttribute) : undefined;

      if (attrAfter !== attrBefore) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return false;
}